import React, { useState, useEffect } from 'react';

function InternetCheck() {
  const [isConnected, setIsConnected] = useState(window.navigator.onLine);

  useEffect(() => { console.log(window.navigator.onLine)
    const updateNetwork = () => {
     
      setIsConnected(window.navigator.onLine);
    };

    window.addEventListener('online', updateNetwork);
    window.addEventListener('offline', updateNetwork);

    return () => {
      window.removeEventListener('online', updateNetwork);
      window.removeEventListener('offline', updateNetwork);
    };
  }, [isConnected]);

  return (
    <div>
      <h1>Internet Connection Status:</h1>
      <p>{isConnected ? 'Online' : 'Offline'}</p>
    </div>
  );
}

export default InternetCheck;
